/**
 * 十八反十九畏模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取十八反十九畏列表
export const effectsList = (params) => {
  return req.get('/hosp/effects/list', params);
}

// 新增十八反十九畏
export const effectsAdd = (params) => {
  return req.post('/hosp/effects', params);
}

// 删除十八反十九畏信息
export const effectsDelete = (effectsId) => {
  return req.delete(`/hosp/effects/${effectsId}`);
}

// 划价判断
export const pricingJudge = (params) => {
  return req.post('/hosp/effects/payment', params);
}

// 开方判断
export const prescriptionJudge = (params) => {
  return req.post('/hosp/effects/recipe', params);
}